// components/mapOperations/OpenSeaMapToggle.tsx
import { FC } from 'react';
import { Switch } from '@heroui/react';
import { FaAnchor   } from 'react-icons/fa';
import { BiHide } from "react-icons/bi";

interface OpenSeaMapToggleProps {
  isVisible: boolean;
  onToggle: () => void;
}

const OpenSeaMapToggle: FC<OpenSeaMapToggleProps> = ({ isVisible, onToggle }) => {
  return (
    <div className="absolute z-10 opacity-85 ml-2" style={{ bottom: 71, right: 10 }}>
			<Switch
				classNames={{
					wrapper: 'rounded',
					thumb: 'rounded',
				}}
				size="sm"
				onChange={onToggle}
				color="default"
				startContent={<BiHide />}
				endContent={<FaAnchor   />}
				title={isVisible ? 'Hide Nautical Charts' : 'Show Nautical Charts'}        
			/>
		</div>
  );
};


export default OpenSeaMapToggle;
